/**
 * abtestid 数据在页面间共享
 * @Author: moonye
 * @Date: 2019-06-20 14:34:45
 * @Last Modified by: moonye
 * @Last Modified time: 2019-09-18 14:49:46
 */

import cookie from '@tencent/im-cookie';
import injectUtil from './util.inject';
import util from './util';

const cookieConfig = {
  name: 'tdw_data_flowid',
  domain: 'ke.qq.com',
  path: '/'
};

const REPORT_SESSION_FLOWID_DOM_KEY = 'data-report-session-flowid';

export function getSessionFlowid() {
  let id = '';
  try {
    id = cookie.get(cookieConfig.name) || '';
  } catch (e) { }

  setId('');
  return id;
}

function setId(ret = '') {
  cookie.setSession(cookieConfig.name, ret, cookieConfig.domain, cookieConfig.path);
}

function clickHandler(finalDom, e) {
  const targetDom = e.target;
  const moduleTarget = util.closest(targetDom, `[${REPORT_SESSION_FLOWID_DOM_KEY}]`);
  const testid = moduleTarget && moduleTarget.getAttribute(REPORT_SESSION_FLOWID_DOM_KEY) || '';
  setId(testid);
}

injectUtil.addListener(clickHandler);

